import IconSvg from './assets/icons/32/error.svg';
import { FC } from 'react';
const Icon: FC = () => <img alt="error" src={IconSvg} width="32px" height="32px" />;

export default Icon;
